import TicketPurchaseContainer from "../../../Component/Application/PurchaseTicket/TicketPurchaseContainer";

const TicketPurchasePage = () => {
    return (
        <div className="page-body">
            <TicketPurchaseContainer />
        </div>
    );
};

export default TicketPurchasePage;